import Vue from "vue";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import "./styles/design-system.css";

import router from "./router";
import store from "./store";

require("@/store/subscriber");

require("./mixin.js");
require('./filters.js')

// Setup axios interceptors after store is available 
import { setupInterceptors } from "./axios.js";
setupInterceptors(store);

Vue.config.productionTip = false;

import PageHeader from "@/components/PageHeader.vue";
import StatusChip from "@/components/StatusChip.vue";
import EmptyState from "@/components/EmptyState.vue";
import HealthLoader from "@/components/HealthLoader.vue";
Vue.component("PageHeader", PageHeader);
Vue.component("StatusChip", StatusChip);
Vue.component("EmptyState", EmptyState);
Vue.component("HealthLoader", HealthLoader);

import JsonExcel from "vue-json-excel";
Vue.component("downloadExcel", JsonExcel);

import CryptoJS from "crypto-js";
window.CryptoJS = CryptoJS;
// Vue.component("CryptoJS", CryptoJS);


store.dispatch("auth/attempt", localStorage.getItem("token")).then(() => {
  new Vue({
    router,
    store,
    vuetify,
    render: (h) => h(App),
  }).$mount("#app");
});
